import { render } from "./DeleteShiftModal.vue?vue&type=template&id=2c73d00e&ts=true"
import script from "./DeleteShiftModal.vue?vue&type=script&lang=ts"
export * from "./DeleteShiftModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__